var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper",staticStyle:{"background-color":"#f8f9fb"}},[_c('router-view'),(_vm.showSignIn)?_c('SignIn'):_vm._e(),(_vm.showSignUp)?_c('SIgnUp'):_vm._e(),_c('SnackBar',{attrs:{"snackbarInfo":_vm.snackbarInfo}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }